<template>
  <div>
    <b-row align-h="between" style="margin-left: 0; margin-right: 0;">
      <h3>Alle Kategorien:</h3>
      <div>
        <b-button variant="outline-primary" to="Kalender/Neu">Erstellen</b-button>
      </div>
    </b-row>
    <b-table :items="calendars" :fields="fields" @row-clicked="openCalendarEdit" :hover="true">
      <template v-slot:cell(color)="data">
        <span :style="'background-color: ' + data.item.color" class="colorCell">{{ data.item.color }}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import router from '@/router'

export default {
  name: 'CalendarList',
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: '#'
        },
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'color',
          label: 'Farbe'
        },
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getStoredCalendars',
    ]),
    calendars() {
      return this.getStoredCalendars
    },
  },
  mounted() {
    this.getCalendars()
  },
  methods: {
    ...mapActions([
      'getCalendars',
    ]),
    openCalendarEdit(item) {
      router.push('Kalender/' + item.id)
    }
  }
}
</script>

<style scoped>
.colorCell {
  color: transparent;
  width: 8rem;
  height: calc(2rem + 16px);
  transform: translate(-2rem, -12px);
  position: absolute;
}
</style>
